<template>
<div>
    <div class="table-responsive">
        <table class="table table-bordered table-sm table-hover">
            <thead>
                <tr>
                    <th>Cliente</th>
                    <th>imei</th>
                    <th>Registro</th>
                    <th>Modelo</th>
                    <th>Prefixo</th>
                    <th>Codinome</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        {{form.equipamento.nomeCliente}}
                    </td>
                    <td>
                        {{form.equipamento.imei}}
                    </td>
                    <td>
                        {{form.equipamento.registro}}
                    </td>
                    <td>
                        {{form.equipamento.modelo}}
                    </td>
                    <td>
                        {{form.equipamento.prefixo}}
                    </td>
                    <td>
                        {{form.equipamento.codinome}}
                    </td>
                </tr>

            </tbody>
        </table>

        <table class="table table-bordered table-sm table-hover">
            <thead>
                <tr>
                    <th colspan="7">TRECHO</th>
                </tr>
                <tr>
                    <th>Data<br/><small>UTC</small></th>
                    <th>Acionamento<br/><small>UTC</small></th>
                    <th>Decolagem<br/><small>UTC</small></th>
                    <th>Pouso<br/><small>UTC</small></th>
                    <th>Corte<br/><small>UTC</small></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        {{trecho._data}}
                        <br/>
                        <small>{{trecho._dataUTC}}</small>
                    </td>
                    <td>
                        {{trecho.acionamento}}
                        <br/>
                        <small>{{trecho._acionamentoUTC}}</small>
                    </td>
                    <td>
                        {{trecho.decolagem}}
                        <br/>
                        <small>{{trecho._decolagemUTC}}</small>
                    </td>
                    <td>
                        {{trecho.pouso}}
                        <br/>
                        <small>{{trecho._pousoUTC}}</small>
                    </td>
                    <td>
                        {{trecho.corte}}
                        <br/>
                        <small>{{trecho._corteUTC}}</small>
                    </td>
                </tr>

            </tbody>
        </table>

		<ul class="nav nav-tabs">
			<li class="nav-item">
				<a class="nav-link" :class="{'active' : tab == 'P'}" @click.prevent="tab = 'P'" href="#">POSIÇÕES</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" :class="{'active' : tab == 'M'}"  @click.prevent="tab = 'M'" href="#">MAPA</a>
			</li>
		</ul>

        <table  v-if="tab == 'P'" class="table table-sm table-hover" >
            <thead>
                <tr>
                    <th>Lat</th>
                    <th>Lng</th>
                    <th>Altitude</th>
                    <th>Data<br/> <small>UTC</small></th>
                    <th>Velocidade</th>
                    <th>Em Movimento</th>
                    <th>Tigger</th>
                    <th>Switch</th>
                </tr>
            </thead>
            <tbody>
                <tr :class="{'text-success' : it.voando || it.pousou}" v-for="(it, index) in posicoes" :key="index">
                    <td>{{it.lat}}</td>
                    <td>{{it.lng}}</td>
                    <td>{{it.altitude}}</td>
                    <td>{{it.data}}<br/><small>{{it._dataUTC}}</small></td>
                    <td>{{it.velocidade}}</td>
                    <td>
                        {{it.emMovimento}}
                    <td>{{it.trigger}}</td>
                    <td>{{it.alertType}}</td>
                </tr>
            </tbody>
			<tfoot v-if="posicoes.length == 0">
				<tr>
					<td colspan="8">
						Nenhuma posição encontrada.
					</td>
				</tr>
			</tfoot>
        </table>

		<div style="margin-top:20px" v-if="tab == 'M' && posicoes.length == 0">
			Nenhuma posição encontrada.
		</div>

        <div v-show="tab == 'M' && posicoes.length > 0" style="width: 100%; height: 500px; margin-bottom:20px">
            <div ref="map" style="width: 100%; height: 100%"></div>
        </div>
    </div>
</div>
</template>

<script>

import $mapa from '../../../../library/mapa.js'
export default {
    props: {
        posicoes: {
            type: Array,
            required: true,
            default: () => { return  [] },
        },

        form: {
            type: Object,
            required: true,
        },

        trecho: {
            type: Object,
            required: true,
        }
	},

	mixins: [$mapa],

	data () {
		return {
			tab: 'M'
		}
	},

    methods: {

        carregaMapa(){
            this.$nextTick(() => {
                this.plotaMapa(this.posicoes);
            });
        },

		plotaMapa(posicoes) {

			this.removePolylines()
			this.removeMarkers()

			if(posicoes.length > 0){
				var latInit = parseFloat(posicoes[0].lat);
				var lgnInit = parseFloat(posicoes[0].lng);

				this.iniciaMapa(this.$refs.map, latInit, lgnInit, 8)

				this.adicionaBotoes()

				this.geraPolylines(posicoes)

				this.geraMarkers(posicoes)

				setTimeout(() => {
					this.fitBoundsList(posicoes)
				}, 1000);
			}
        },
    },
}
</script>




// WEBPACK FOOTER //
// src/views/equipamento/detalhe/trecho/posicoes.vue